import "aos/dist/aos.css";
import { useContext } from "react";
import { AppContext } from "../AppProvider";
import { ImagesSliderComponent } from "../Components/Banner/BannerNext";
import AboutSection from "../Components/Home/AboutSection";
import Blog from "../Components/Home/Blog";
import SectoralArea from "../Components/Home/CarouselComponent";
import Count from "../Components/Home/Count";
import TestimonialComponent from "../Components/Home/TestomonialComponent";
import { RecentProject } from "../Components/RecentProject/RecentProject";
import StrategicPartner from "../Components/StrategicPartner/StrategicPartner";
import CBSGCharLoader from "./CBSGCharLoader";

const Home = () => {
  const { homeText: companyProfile, loading, error } = useContext(AppContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[40rem]">
        <CBSGCharLoader />
        {/* <span className="loading loading-bars loading-lg"></span> */}
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-[40rem]">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  const CountData = {
    contracts_international_agencies:
      companyProfile?.contracts_international_agencies,
    research_evaluation_assignments:
      companyProfile?.research_evaluation_assignments,
    organizational_capacity_assessment:
      companyProfile?.organizational_capacity_assessment,
    us_government_project: companyProfile?.us_government_project,
    years_of_experience: companyProfile?.years_of_experience,
  };
  const AboutData = {
    about_text: companyProfile?.about_text,
    organization_development_image:
      companyProfile?.organization_development_image,
    organization_development_text:
      companyProfile?.organization_development_text,
    organization_development_title:
      companyProfile?.organization_development_title,
    research_evaluation_image: companyProfile?.research_evaluation_image,
    research_evaluation_text: companyProfile?.research_evaluation_text,
  };
  const practice_caption = companyProfile?.practice_caption;

  return (
    <div className=" mb-20">
      <ImagesSliderComponent />
      <div>
        <Count CountData={CountData} />
      </div>
      <AboutSection AboutData={AboutData} />
      <Line />
      <div className="px-10">
        <SectoralArea practice_caption={practice_caption} />
      </div>
      <Line />
      <RecentProject />
      <Line />

      <div>
        <div
          className="w-full flex flex-col items-center justify-center mt-20 p-10"
          data-aos="fade-up"
        >
          <p className="text-xl md:text-5xl font-bold text-base_600 bg-gradient-to-tr from-base_900 to-base_500 bg-clip-text text-transparent ">
            Our Clients and Partners
          </p>
        </div>
        <StrategicPartner data-aos="fade-up" />
      </div>
      <Line />
      <TestimonialComponent />
      <section>
        <Blog />
      </section>
    </div>
  );
};
export default Home;
const Line = () => {
  return (
    <div className="w-full h-3 grid grid-cols-3 bg-black mt-10">
      <div className="bg-base_500"></div>
      <div className="bg-yellow-500"></div>
      <div className="bg-violet-950"></div>
    </div>
  );
};
